export * from './text-highlight.component';
export * from './text-highlight.module';
